const $cookies = require('vue-cookies')
const configs = require('../config/configs')

const moduleFunc = {
  getTicket: () => {
    return $cookies.get('FEEC-FA-TOKEN')
  },
  getMemberId: () => {
    return $cookies.get('FEEC-B2C-UID')
  },
  addToCartBeforeCheck: () => {
    const ticket = moduleFunc.getTicket()
    const memberID = moduleFunc.getMemberId()
    if (!ticket || !memberID) {
      window.location.href = configs.loginUrl();
      return false
    } else {
      return true
    }
  }
}
module.exports = moduleFunc
